const translations = {
    clear: 'Clear',
    loading: 'Loading…',
    noResults: 'No matching sites',
    searchPlaceholder: 'Search existing sites…'
};

export default translations;
